<div [hidden]="!loading" class="spinner">
  <div class="sk-spinner sk-spinner-pulse"></div>
</div>
<div class="hr-line-dashed"></div>
<form (ngSubmit)="onSubmit()" class="pos-relative form">
  <div class="form-group">
    <div class="d-flex justify-content-start align-items-center gap-10 my-15">
      <label class="w-25">Referral</label>
      <div class="d-flex justify-content-start align-items-center gap-10">
        <input class="form-control" [value]="getBalanceSum('REFERRAL') | number: '1.1-2'" disabled>
        <input [(ngModel)]="model.REFERRAL.newValue" type="number" step="0.01" class="form-control" [ngModelOptions]="{standalone: true}">
      </div>
    </div>
    <div class="d-flex justify-content-start align-items-center gap-10 my-15">
      <label class="w-25">In. SMS</label>
      <div class="d-flex justify-content-start align-items-center gap-10">
        <input class="form-control" [value]="getBalanceSum('MT_SMS') | number: '1.1-2'" disabled>
        <input [(ngModel)]="model.MT_SMS.newValue" type="number" step="0.01" class="form-control" [ngModelOptions]="{standalone: true}">
      </div>
    </div>
    <div class="d-flex justify-content-start align-items-center gap-10 my-15">
      <label class="w-25">Out. SMS</label>
      <div class="d-flex justify-content-start align-items-center gap-10">
        <input class="form-control" [value]="getBalanceSum('MO_SMS') | number: '1.1-2'" disabled>
        <input [(ngModel)]="model.MO_SMS.newValue" type="number" step="0.01" class="form-control" [ngModelOptions]="{standalone: true}">
      </div>
    </div>
    <div class="d-flex justify-content-start align-items-center gap-10 my-15">
      <label class="w-25">CLI</label>
      <div class="d-flex justify-content-start align-items-center gap-10">
        <input class="form-control" [value]="getBalanceSum('CALL') | number: '1.1-2'" disabled>
        <input [(ngModel)]="model.CALL.newValue" type="number" step="0.01" class="form-control" [ngModelOptions]="{standalone: true}">
      </div>
    </div>
    <div class="d-flex justify-content-start align-items-center gap-10 my-15">
      <label class="w-25">Bonus</label>
      <div class="d-flex justify-content-start align-items-center gap-10">
        <input class="form-control" [value]="getBalanceSum('BONUS') | number: '1.1-2'" disabled>
        <input [(ngModel)]="model.BONUS.newValue" type="number" step="0.01" class="form-control" [ngModelOptions]="{standalone: true}">
      </div>
    </div>
    <div class="d-flex justify-content-start align-items-center gap-10 my-15">
      <label class="w-25 fw-bold">RESULT</label>
      <div class="d-flex justify-content-end w-75 me-40 my-10">
        <span class="fw-bold">{{getBalanceSum() | number: '1.1-2'}}</span>
      </div>
    </div>
  </div>
  <hr>
  <div class="d-flex justify-content-end my-15">
    <button id="btn-appscripts-balance-save" type="submit" class="btn btn-primary m-b px-15">Save</button>
  </div>
</form>

<style>
  .table-val {
    font-size: 16px;
    font-weight: bold;
  }

  .buttons {
    margin: 15px;
  }

  .text-right {
    text-align: right;
  }
</style>
